import { render, staticRenderFns } from "./Preguntar.vue?vue&type=template&id=a23a5122&scoped=true&"
import script from "./Preguntar.vue?vue&type=script&lang=js&"
export * from "./Preguntar.vue?vue&type=script&lang=js&"
import style0 from "./Preguntar.vue?vue&type=style&index=0&id=a23a5122&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23a5122",
  null
  
)

export default component.exports